import { LoggerHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';

import { useBlockStepManagerContext } from './blockStepManager.context';

export const useBlockStepManager = () => {
	const { blocks, setState } = useBlockStepManagerContext();

	const goto = (blockName: string, isOpen = true) => {
		const blockIndex = blocks?.findIndex((b) => b.name === blockName);

		setState((currentState) => {
			/* create a new array based on the current state, 
            and set isOpen to false to all block */
			const newStateBlocks = currentState.blocks ? [...currentState.blocks] : [];

			if (blockIndex !== -1) {
				newStateBlocks.splice(blockIndex || 0, blocks?.length);
			}

			const newBlocks = newStateBlocks.map((b) => ({
				...b,
				isOpen: false,
			}));

			newBlocks.push({
				name: blockName,
				isOpen,
			});

			LoggerHelper.log('BlockStepManager', 'useBlockStepManager > goto():', {
				input: { blockName, isOpen },
				output: {
					newBlocks,
				},
			});

			return {
				...currentState,
				blocks: newBlocks,
			};
		});
	};

	const openPrevious = () => {
		setState((currentState) => {
			const newBlocks = currentState.blocks ? [...currentState.blocks] : [];
			if (newBlocks.length > 1) {
				newBlocks[newBlocks.length - 2].isOpen = true;
			}

			return {
				...currentState,
				blocks: newBlocks,
			};
		});
	};

	return { blocks, goto, openPrevious };
};
